/*
  Maak je set compleet (sections/bb-complete-set.liquid).
  Haalt productaanbevelingen op met de gevraagde intent (complementary of
  related) en, als die is ingesteld, tegelijk de fallback-intent. De eerste
  met resultaten wordt getoond. Blijft het leeg, dan verdwijnt de sectie.
*/
class BbRecommendations extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.productId) return;
    const observer = new IntersectionObserver(
      (entries, obs) => {
        if (!entries[0].isIntersecting) return;
        obs.unobserve(this);
        this.load();
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    observer.observe(this);
  }

  async fetchIntent(intent) {
    const url = `${this.dataset.url}&product_id=${this.dataset.productId}&section_id=${this.dataset.sectionId}&intent=${intent}`;
    const response = await fetch(url);
    if (!response.ok) return null;
    const html = document.createElement('div');
    html.innerHTML = await response.text();
    const element = html.querySelector('bb-recommendations');
    return element && element.querySelector('.grid__item') ? element : null;
  }

  async load() {
    try {
      const intent = this.dataset.intent || 'complementary';
      const intents = [intent];
      if (this.dataset.fallback && this.dataset.fallback !== intent) intents.push(this.dataset.fallback);
      /* Beide intents tegelijk ophalen; de eerste met resultaten wint. */
      const results = await Promise.all(intents.map((name) => this.fetchIntent(name).catch(() => null)));
      const result = results.find(Boolean);
      if (result) {
        this.innerHTML = result.innerHTML;
        this.classList.add('bb-recommendations--loaded');
        return;
      }
      this.removeSection();
    } catch (error) {
      console.error(error);
    }
  }

  removeSection() {
    if (window.Shopify && window.Shopify.designMode) {
      this.hidden = true;
      return;
    }
    (this.closest('.shopify-section') || this).remove();
  }
}

if (!customElements.get('bb-recommendations')) {
  customElements.define('bb-recommendations', BbRecommendations);
}
